<template>
  <div id="BannerWrapper">
    <div id="BannerContent">
      <h1>{{ title }}</h1>
      <p v-html="tag"></p>
    </div>
    <div id="BannerImg"  :style="{'background-image': 'url(' + banner_image + ')'}" class="parallax-background"  data-paroller-factor="-0.12" data-paroller-factor-sm="-0.10" data-paroller-factor-xs="-0.09" ></div>
  </div>
</template>

<script>
export default {
  name: 'Banner',
  data () {
    return {
      title: 'Earn Passive Income with Alternative Investments',
      tag: 'More than just a <br/> reliable rate of return!',
      banner_image: require('.././assets/img/home-banner.jpg')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1{ line-height:1.2em; font-size: 2.92em; }
  p{ line-height:1.2em; font-size: 1.9em; }
</style>


// WEBPACK FOOTER //
// src/components/Banner.vue